export const REPORT_NAMES = {
  COMPACT_VIEW: 'compact-view',
  COMPACT_VIEW_SPREAD_SHEETS: 'compact-view-spread-sheets',
  FULL_VIEW: 'full-view',
  FULL_VIEW_TOTAL: 'full-view-total',
  SALES_KPI: 'sales-kpi',
  FILTER_OPTIONS: 'filter-options',

  COEFFICIENT_V1: 'coefficient-v1',
  COEFFICIENT_V2: 'coefficient-v2',
  COEFFICIENT_HELP: 'coefficient-help',

  DECOMP_MODEL: 'decomp-model',
  DECOMP_MODEL_TOTAL: 'decomp-model-total',
  DECOMP_MODEL_WATERFALL: 'decomp-model-waterfall',
  DECOMP_MODEL_WATERFALL_TOTAL: 'decomp-model-waterfall-total',

  DECOMP_MODEL_WATERFALL_CHART: 'decomp-model-waterfall-chart',

  PBI_DECOMP_MODEL: 'decomp-model-chart',
  PBI_DECOMP_MODEL_WATERFALL: 'decomp-model-waterfall-chart',

  DECOMP_MODEL_INSIGHTS_CHART: 'decomp-model-insights-chart',
  DECOMP_MODEL_INSIGHTS_DETAILS_CHART: 'decomp-model-insights-details-chart',
  DECOMP_MODEL_INSIGHTS_DETAILS_CHART_DRILLDOWN:
    'decomp-model-insights-details-chart-drilldown',
  DECOMP_MODEL_INSIGHTS_DETAILS_CHART_TOTAL:
    'decomp-model-insights-details-chart-total',
  DECOMP_MODEL_INSIGHTS_DETAILS_CHART_SUMMARY:
    'decomp-model-insights-details-chart-summary',

  DEMAND_MODEL_CHART: 'demand-model-chart',

  DECOMP_MODEL_DISTRIBUTION: 'decomp-model-distribution',
  DECOMP_MODEL_DISTRIBUTION_TOTAL: 'decomp-model-distribution-total',

  DECOMP_MODEL_CHART: 'decomp-model-chart',
  DECOMP_MODEL_CHART_TOTAL: 'decomp-model-chart-total',

  DEMAND_MODEL_REFRESH_INFO: 'demand-model-refresh-info',
  DECOMP_MODEL_REFRESH_INFO: 'decomp-model-refresh-info',
  FILTER_REFRESH_INFO: 'filter-refresh-info',
  DECOMP_INSIGHTS_REFRESH_INFO: 'decomp-insights-refresh-info',

  BANNER_MESSAGE: 'banner-message',

  NETFLOW_VOLUME: 'netflow-volume',
  NETFLOW_MATRIX: 'netflow-matrix',
  NETFLOW_DRILL_THROUGH_BY_DEST: 'netflow-drill-through-by-dest',
  NETFLOW_DRILL_THROUGH_BY_DEST_TOTAL: 'netflow-drill-through-by-dest-total',
  NETFLOW_DRILL_THROUGH_BY_SOURCE: 'netflow-drill-through-by-source',
  NETFLOW_DRILL_THROUGH_BY_SOURCE_TOTAL:
    'netflow-drill-through-by-source-total',
  NETFLOW_DRILL_THROUGH_BY_SOURCE_METRICS:
    'netflow-drill-through-by-source-metrics',

  NETFLOW_NODES: 'netflow-nodes',
  NETFLOW_METRICS: 'netflow-metrics',
  NETFLOW_METRICS_DETAILS: 'netflow-metrics-details',

  ACCESS_INFO: 'access-info',
  // Scenario Planner
  SCENARIO_PLANNER_CALCS: 'scenario-planner-calcs',
  SCENARIO_PLANNER_CALCS_TOTAL: 'scenario-planner-calcs-total',
  SCENARIO_PLANNER_KC_MANUF: 'scenario-planner-kc-manuf',
  SCENARIO_PLANNER_DATA: 'scenario-planner-data',
  SCENARIO_PLANNER_DATA_TOTAL: 'scenario-planner-data-total',
  SCENARIO_PLANNER_SUMMARY_REPORT: 'scenario-planner-summary-report',
  SCENARIO_PLANNER_PPG_SUMMARY_REPORT: 'scenario-planner-ppg-summary-report',
  SCENARIO_PLANNER_DETAILS_REPORT: 'scenario-planner-details-report',
  SCENARIO_PLANNER_TIMEFRAME_REPORT: 'scenario-planner-timeframe-report',
  SCENARIO_PLANNER_SUMMARY_MANUFACTURER:
    'scenario-planner-summary-manufacturer',
  SCENARIO_PLANNER_SUMMARY_BRAND: 'scenario-planner-summary-brand',
  SCENARIO_PLANNER_SUMMARY_SUBBRAND: 'scenario-planner-summary-subbrand',
  SCENARIO_PLANNER_SUMMARY_PACK: 'scenario-planner-summary-pack',
  SCENARIO_PLANNER_SCENARIO_SUMMARY: 'scenario-planner-scenario-summary',
  SCENARIO_PLANNER_COMPARISON: 'scenario-planner-comparison',
  /** Main Elasticity Coefficients */
  SCENARIO_PLANNER_MAIN_ELASTICITY: 'scenario-planner-main-elasticity',
  /** Cross Elasticity Coefficients */
  SCENARIO_PLANNER_CROSS_ELASTICITY: 'scenario-planner-cross-elasticity',
  /** Report to show starting metrics and their overwitten values */
  SCENARIO_PLANNER_STARTING_METRIC: 'scenario-planner-starting-metric',
};
